// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Point } from "../../Commons/Geometry.js";
import { ChartMath } from "../Utils/ChartMath.js";
import { TerceraChartCashItemSeriesDataType } from "../Series/TerceraChartCashItemSeriesEnums.js";
import { ToolView } from "./ToolView.js";

export let CurveToolView = function (tool)
{
    ToolView.call(this, tool);
};

CurveToolView.prototype = Object.create(ToolView.prototype);

CurveToolView.prototype.UpdateScreenPoints = function (ww, cashItemSeries)
{
    var dataCacheTool = this.dataCacheTool;
    //
    // callback need recalculate points
    //
    if (dataCacheTool.forceUpdateAdditionalPoints)
    {
        dataCacheTool.forceUpdateAdditionalPoints = false;
        this.UpdateAdditionalPoints(ww, -1, cashItemSeries);
    }
    this.UpdateScreenPointsALL(ww, cashItemSeries, false);

    var dataType = cashItemSeries && cashItemSeries.settings ?
        cashItemSeries.settings.DataType :
        TerceraChartCashItemSeriesDataType.Absolute;

    var tmp = [];
    var pc = ww.PointsConverter;

    var scrPoints_len = this.screenPoints.length;
    for (var i = dataCacheTool.PointLevel() ; i < scrPoints_len; i++)
    {
        var p = dataCacheTool.Points[i];
        var x = pc.GetScreenXbyTime(p[0]);
        var y = 0;
        switch (dataType)
        {
            case TerceraChartCashItemSeriesDataType.Absolute:
                y = pc.GetScreenY(p[1]);
                break;

            case TerceraChartCashItemSeriesDataType.Relative:
                y = pc.GetScreenY(cashItemSeries.settings.relativeDataConverter.Calculate(p[1]));
                break;
            case TerceraChartCashItemSeriesDataType.Log:
                y = pc.GetScreenY(cashItemSeries.settings.logDataConverter.Calculate(p[1]));
                break;
        }

        tmp.push(new Point(x, y));
    }

    this.lastCurvePoints = tmp;
};

CurveToolView.prototype.IsSelectCheck = function (x, y)
{
    var lastCurvePoints = this.lastCurvePoints;
    if (lastCurvePoints)
    {
        var TOOL_DX = ToolView.TOOL_DX;
        var len = lastCurvePoints.length;
        // весь контур 
        for (var i = 1; i < len; i++)
        {
            if (ChartMath.CalcDistanceSqrFromPointToSection([lastCurvePoints[i - 1].X, lastCurvePoints[i - 1].Y], [lastCurvePoints[i].X, lastCurvePoints[i].Y], x, y) <= TOOL_DX)
                return true;
        }
    }

    return ToolView.prototype.IsSelectCheck.call(this, x, y);
};